export default import.meta.ROLLDOWN_FILE_URL_hnI36fgISA9mw3EEmkcdcA